/* eslint-disable react/prop-types */
import React from 'react';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DefaultContext  from "flexbiz-core/components/auth/Context";
import withMediaQuery  from "flexbiz-core/components/withMediaQuery";
import {gradientBackgroundStyle} from "flexbiz-core/utils"
import Cart  from './Cart';
import Swipeable from 'flexbiz-core/components/Swipeable';
const styles = {
  paper: {
    height:"100%"
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: 1,
  },
  submit: {
    margin: '3 0 2 0',
  },
}
class CartForm extends React.Component{
  constructor(props){
    super(props);
    this.state={
      dialogOpen:false,load:0
    }
    this.showForm = this.showForm.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }
  async componentDidMount(){
  }
  shouldComponentUpdate(nextProps,nextStates){
    return nextStates.load!=this.state.load
  }
  async showForm(){
    let state={
      dialogOpen:true,running:false,error:'',load:this.state.load+1
    }
    this.setState(state);
  }
  handleClose(callback){
    this.setState({dialogOpen:false,load:this.state.load+1},()=>{
      if(callback) callback()
    });
  }
  render(){
    const apis = this.context.apis;
    const {mainTextColor,formHeaderColor} = this.context.config;
    let maincolor = (this.context.config.secondaryColor);
    let bg = gradientBackgroundStyle(maincolor,{brightenFirst:this.context.config.fragBrightenFirst ||50,brightenSecond:this.context.config.fragBrightenSecond});
    return (
      <>
        <Dialog
          fullScreen={this.props.mediaQueryMatches}
          fullWidth={true}
          maxWidth={'lg'}
          open={this.state.dialogOpen}
          onClose={()=>this.handleClose()}
        >
          <DialogTitle style={{backgroundColor:formHeaderColor,color:mainTextColor}}>
            <Grid container direction="row" justifyContent="space-between">
              <Grid>
                {apis.getLabel("Giỏ hàng")}
              </Grid>
              <Grid>
                <Button onClick={()=>this.handleClose()} color="secondary">
                  X
                </Button>
              </Grid>
            </Grid>
          </DialogTitle>
          <DialogContent style={{padding:0}}>
            <Swipeable style={{...styles.paper,...bg}} onSwipedRight={this.handleClose}>
              <Cart {...this.props}/>
            </Swipeable>
          </DialogContent>
        </Dialog>
      </>
    );
  }
}
CartForm.contextType = DefaultContext;
export default withMediaQuery('(max-width:480px)')(CartForm);
